module.exports = {"countries":[{"optionGroupLabel":"ASEAN","groupKey":"Asia","options":[{"value":"TH_brunei","label":"Brunei"},{"value":"TH_cambodia","label":"Cambodia"},{"value":"ID","label":"Indonesia"},{"value":"TH_laos","label":"Laos"},{"value":"MY","label":"Malaysia"},{"value":"TH_myanmar","label":"Myanmar"},{"value":"PH","label":"Philippines"},{"value":"SG","label":"Singapore"},{"value":"TH_thailand","label":"Thailand"},{"value":"VN","label":"Vietnam"}]}]}


//////////////////
// WEBPACK FOOTER
// ./src/components/CountrySelector/countries_th.json
// module id = 957
// module chunks = 0